<div class="add-edit-page" [class.loading]="loading">

  <div class="page-header">
    <h2 class="page-title">{{ isEditMode ? 'تعديل مأمورية' : 'إضافة مأمورية جديدة' }}</h2>
    <dx-button text="رجوع" icon="back" stylingMode="outlined" (onClick)="cancel()"></dx-button>
  </div>

  <dx-load-panel [visible]="loading" [showIndicator]="true" message="جاري التحميل..."></dx-load-panel>

  <div *ngIf="!loading">

    <!-- ===== البيانات الأساسية ===== -->
    <div class="card">
      <div class="card-title">📋 البيانات الأساسية</div>
      <div class="form-grid">

        <div class="field">
          <label>الموظف <span class="required">*</span></label>
          <dx-select-box
            [dataSource]="employeesdropdown"
            displayExpr="nameAr"
            valueExpr="id"
            [(value)]="formData.employeeId"
            placeholder="اختر الموظف"
            [searchEnabled]="true">
          </dx-select-box>
        </div>

        <div class="field">
          <label>اسم المأمورية <span class="required">*</span></label>
          <dx-text-box [(value)]="formData.name" placeholder="اسم المأمورية"></dx-text-box>
        </div>

        <div class="field">
          <label>موقع المأمورية</label>
          <dx-text-box [(value)]="formData.missionLocation" placeholder="الموقع"></dx-text-box>
        </div>

        <div class="field">
          <label>نوع المأمورية</label>
          <dx-select-box
            [dataSource]="missionTypes"
            displayExpr="nameAr"
            valueExpr="id"
            [(value)]="formData.missionType">
          </dx-select-box>
        </div>

        <div class="field">
          <label>بداية الزيارة <span class="required">*</span></label>
          <dx-date-box
            [(value)]="formData.visitStartDateTime"
          type="datetime"
  displayFormat="dd/MM/yyyy HH:mm">
          </dx-date-box>
        </div>
        

        <div class="field">
          <label>نهاية الزيارة <span class="required">*</span></label>
          <dx-date-box
            [(value)]="formData.visitEndDateTime"
            type="datetime"
            displayFormat="dd/MM/yyyy HH:mm">
          </dx-date-box>
        </div>

        <div class="field full">
          <label>الوصف</label>
   <dx-text-box [(value)]="formData.descrption" placeholder="وصف المأمورية"></dx-text-box>
        </div>

        <div class="field checkbox-field">
          <dx-check-box [(value)]="formData.isPaid" text="مأمورية مدفوعة"></dx-check-box>
        </div>

      </div>
    </div>

    <!-- ===== بيانات العميل ===== -->
    <div class="card">
      <div class="card-title"> بيانات العميل</div>
      <div class="form-grid">

        <div class="field checkbox-field full">
          <dx-check-box [(value)]="formData.isClientVisit" text="زيارة عميل"></dx-check-box>
        </div>

        <ng-container *ngIf="formData.isClientVisit">
          <div class="field">
            <label>اسم العميل <span class="required">*</span></label>
            <dx-text-box [(value)]="formData.clientName" placeholder="اسم العميل"></dx-text-box>
          </div>
          <div class="field">
            <label>هاتف العميل <span class="required">*</span></label>
            <dx-text-box [(value)]="formData.clientPhone" placeholder="رقم الهاتف"></dx-text-box>
          </div>
        </ng-container>

        <div class="field checkbox-field full">
          <dx-check-box [(value)]="formData.hasUpcomingVisit" text="يوجد زيارة قادمة"></dx-check-box>
        </div>

        <ng-container *ngIf="formData.hasUpcomingVisit">
          <div class="field">
            <label>تاريخ الزيارة القادمة <span class="required">*</span></label>
            <dx-date-box [(value)]="formData.upcomingVisitDate" type="datetime" displayFormat="dd/MM/yyyy HH:mm"></dx-date-box>
          </div>
        </ng-container>

      </div>
    </div>

    <!-- ===== المواصلات ===== -->
    <div class="card">
      <div class="card-title"> المواصلات <span class="required">*</span></div>

      <!-- إضافة مواصلة -->
      <div class="inline-form">
        <dx-text-box [(value)]="newTransportation.fromDestination" placeholder="من" class="inline-field"></dx-text-box>
        <dx-text-box [(value)]="newTransportation.toDestination" placeholder="إلى" class="inline-field"></dx-text-box>
        <dx-number-box [(value)]="newTransportation.cost" placeholder="التكلفة" [min]="0" class="inline-field sm"></dx-number-box>
        <dx-date-box [(value)]="newTransportation.fromTime" type="datetime" placeholder="وقت الانطلاق" displayFormat="dd/MM HH:mm" class="inline-field"></dx-date-box>
        <dx-date-box [(value)]="newTransportation.toTime" type="datetime" placeholder="وقت الوصول" displayFormat="dd/MM HH:mm" class="inline-field"></dx-date-box>
        <dx-button icon="plus" type="Add" (onClick)="addTransportation()"></dx-button>
      </div>

      <!-- جدول المواصلات -->
      <dx-data-grid
        [dataSource]="formData.transportations"
        [showBorders]="true"
        [rtlEnabled]="true"
        [columnAutoWidth]="true"
        style="margin-top:10px">
        <dxi-column dataField="order" caption="#" [width]="50"></dxi-column>
        <dxi-column dataField="fromDestination" caption="من"></dxi-column>
        <dxi-column dataField="toDestination" caption="إلى"></dxi-column>
        <dxi-column dataField="cost" caption="التكلفة" format="#,##0.00" [width]="100"></dxi-column>
        <dxi-column dataField="fromTime" caption="وقت الانطلاق" dataType="datetime" format="dd/MM/yyyy HH:mm"></dxi-column>
        <dxi-column dataField="toTime" caption="وقت الوصول" dataType="datetime" format="dd/MM/yyyy HH:mm"></dxi-column>
        <dxi-column caption="حذف" [width]="70" cellTemplate="deleteTransTemplate"></dxi-column>
        <div *dxTemplate="let cell of 'deleteTransTemplate'">
          <dx-button icon="trash" type="danger" stylingMode="text" (onClick)="removeTransportation(cell.rowIndex)"></dx-button>
        </div>
      </dx-data-grid>

      <div class="subtotal">إجمالي المواصلات: <strong>{{ transportationTotal | number:'1.2-2' }}</strong></div>
    </div>

    <!-- ===== التكاليف الأخرى ===== -->
    <div class="card">
      <div class="card-title"> تكاليف أخرى</div>

      <!-- إضافة تكلفة -->
      <div class="inline-form">
        <dx-text-box [(value)]="newExpense.description" placeholder="البيان" class="inline-field"></dx-text-box>
        <dx-number-box [(value)]="newExpense.amount" placeholder="المبلغ" [min]="0" class="inline-field sm"></dx-number-box>
        <dx-button icon="plus" type="Add" (onClick)="addExpense()"></dx-button>
      </div>

      <!-- جدول التكاليف -->
      <dx-data-grid
        [dataSource]="formData.expenses"
        [showBorders]="true"
        [rtlEnabled]="true"
        [columnAutoWidth]="true"
        style="margin-top:10px">
        <dxi-column dataField="description" caption="البيان"></dxi-column>
        <dxi-column dataField="amount" caption="المبلغ" format="#,##0.00" [width]="120"></dxi-column>
        <dxi-column caption="حذف" [width]="70" cellTemplate="deleteExpTemplate"></dxi-column>
        <div *dxTemplate="let cell of 'deleteExpTemplate'">
          <dx-button icon="trash" type="danger" stylingMode="text" (onClick)="removeExpense(cell.rowIndex)"></dx-button>
        </div>
      </dx-data-grid>

      <div class="subtotal">إجمالي التكاليف الأخرى: <strong>{{ expensesTotal | number:'1.2-2' }}</strong></div>
    </div>

    <!-- ===== التحصيل ===== -->
    <div class="card">
      <div class="card-title"> التحصيل من العميل</div>
      <div class="form-grid">

        <div class="field checkbox-field full">
          <dx-check-box [(value)]="formData.isCollectedFromClient" text="تم التحصيل من العميل"></dx-check-box>
        </div>

        <ng-container *ngIf="formData.isCollectedFromClient">
          <div class="field">
            <label>المبلغ المحصل <span class="required">*</span></label>
            <dx-number-box [(value)]="formData.collectedAmountFromClient" [min]="0" format="#,##0.00"></dx-number-box>
          </div>
          <div class="field">
            <label>تاريخ التحصيل</label>
            <dx-date-box [(value)]="formData.collectionDate" type="datetime" displayFormat="dd/MM/yyyy HH:mm"></dx-date-box>
          </div>
          <div class="field full">
            <label>سبب التحصيل <span class="required">*</span></label>
            <dx-text-box [(value)]="formData.collectionReason" placeholder="سبب التحصيل"></dx-text-box>
          </div>
        </ng-container>

      </div>
    </div>

    <!-- ===== ملخص مالي ===== -->
    <div class="card financial-summary-card">
      <div class="card-title"> الملخص المالي</div>
      <div class="summary-table">
        <div class="summary-row">
          <span>إجمالي المواصلات</span>
          <span>{{ transportationTotal | number:'1.2-2' }}</span>
        </div>
        <div class="summary-row">
          <span>إجمالي التكاليف الأخرى</span>
          <span>{{ expensesTotal | number:'1.2-2' }}</span>
        </div>
        <div class="summary-row total">
          <span>إجمالي تكلفة المأمورية</span>
          <span>{{ totalCost | number:'1.2-2' }}</span>
        </div>
        <div class="summary-row collected" *ngIf="formData.isCollectedFromClient">
          <span>التحصيل من العميل</span>
          <span>- {{ formData.collectedAmountFromClient | number:'1.2-2' }}</span>
        </div>
        <div class="summary-row net" [class.negative]="netCost < 0">
          <span>{{ netCost < 0 ? '⚠️ الموظف مدين للشركة' : '✅ صافي مستحق للموظف' }}</span>
          <span>{{ (netCost < 0 ? -netCost : netCost) | number:'1.2-2' }}</span>
        </div>
      </div>
    </div>

    <!-- ===== أزرار الحفظ ===== -->
    <div class="actions-bar">
      <dx-button
        [text]="isEditMode ? 'حفظ التعديلات' : 'إضافة المأمورية'"
        type="default"
        stylingMode="contained"
        [disabled]="submitting"
        (onClick)="submit()">
      </dx-button>
      <dx-button
        text="إلغاء"
        type="normal"
        stylingMode="outlined"
        (onClick)="cancel()">
      </dx-button>
    </div>

  </div>
</div>
